import React from 'react'
import PropTypes from 'prop-types'

const Logo = ({ isLoggedIn, showSearchbox, onlyMin, hideUnder }) => {
  const hideOnSmallScreen = !isLoggedIn && showSearchbox
  const noMargin = isLoggedIn && showSearchbox

  return (
    <a
      href='/'
      className={`item ${onlyMin ? 'min-logo' : 'logo'}${hideOnSmallScreen ? ' hide-under-701-screen' : ''}${
        noMargin ? ' logo-0-margin' : ''
      }${hideUnder ? ` hide-under-${hideUnder}-screen` : ''}`}
      aria-label='logo'
    />
  )
}

Logo.propTypes = {
  isLoggedIn: PropTypes.bool,
  showSearchbox: PropTypes.bool,
  onlyMin: PropTypes.bool,
  hideUnder: PropTypes.number
}

export default Logo
